<template>
  <SeoLinks v-if="seoLinksList" class="my-32 md:my-72" :links="seoLinksList" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { uniqBy } from '@backmarket/utils/collection/uniqBy'

import SeoLinks from '~/scopes/product-core/components/presentationals/SeoLinks/SeoLinks.vue'

import { useFetchLinkBooster } from './composables/useFetchLinkBooster/useFetchLinkBooster'
import { useFetchSiblings } from './composables/useFetchSiblings/useFetchSiblings'

const { data: siblings } = useFetchSiblings()
const { data: linkBoosters } = useFetchLinkBooster()

const seoLinksList = computed(() =>
  uniqBy([...(siblings.value || []), ...(linkBoosters.value || [])], 'title'),
)
</script>
